<template>
  <div v-loading="loading" class="mrkOverflow">
    <div class="pageFlex">
      <gt-customerInfo :member-info="memberInfo" :search-val="searchVal" :refresh-data="refreshData"></gt-customerInfo>

      <div v-if="isPartPay == 1" class="margin-top-20">
        <el-collapse v-model="serviceNames">
          <el-collapse-item title="消费清单" name="1">
            <yz-consumption-list :service-items="{serveItemsList: [],itemsSumTotal: 0}" :product-sales="{productSalesList: [],productsSumTotal: 0}" :vip-card="vipCard" :consumption-list="consumptionList"></yz-consumption-list>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div v-else class="service-items">
        <el-table :data="[{}]" tooltip-effect="light">
          <el-table-column label="套餐名称" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-show="scope">{{ packageInfo.vipCardName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="原价（元）" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-show="scope">{{ isPrice() }}<el-popover v-if="packageInfo.isWholesale == 0 && editOldPriceStatus != 1" placement="bottom-start" trigger="click">
                <div class="editPrice">
                  <p>改原价</p>
                  <el-input v-model="editPrice" class="epInput" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" placeholder="请输入改价金额">
                    <template slot="prepend">￥</template>
                  </el-input>
                  <div class="epBtn">
                    <el-button @click="resetPrice">重置</el-button>
                    <el-button type="primary" @click="comfirmEditPrice">确定</el-button>
                  </div>
                </div>
                <i v-if="isPartPay != 1" slot="reference" class="iconfont" style="cursor: pointer;color: #BFCBD9;padding-left: 5px;">&#xe684;</i>
              </el-popover></span>
            </template>
          </el-table-column>
          <el-table-column label="折后价（元）" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-show="scope">{{ discountPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column label="优惠权益" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div v-show="scope" v-if="packageInfo.qyCheckBox ? packageInfo.qyCheckBox.length > 0 ? true : false : false" class="themeFC" style="cursor: pointer;" @click="isPartPay == 1 ? '' : chooseRI(packageInfo)">{{ getChooseQyinfo(packageInfo) }}</div>
              <yz-btn v-else size="mini" :type="isPartPay == 1 ? 'disabled' : 'primary'" :disabled="isPartPay == 1 ? true : false" @click="isPartPay == 1 ? '' : chooseRI(packageInfo)">选择优惠权益</yz-btn>
            </template>
          </el-table-column>
          <el-table-column prop="count" label="数量" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-input-number v-show="scope" v-model.trim="rechargeNum" style="width: 100px;" :disabled="isPartPay == 1 ? true : false" class="btnOne" size="mini" :min="1" :max="9999"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="小计（元）" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-show="scope">{{ (discountPrice*rechargeNum).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div v-show="scope" v-if="percentage4PackageList.length > 0" class="themeFC" style="cursor: pointer;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" @click="isPartPay == 1 ? '' : chooseMerchandiser()">
                <span v-for="(item,index) in percentage4PackageList" :key="index">{{ item.technicianName }}{{ percentage4PackageList.length == (index+1) ? '' : '，' }}</span>
              </div>
              <yz-btn v-else size="mini" :type="isPartPay == 1 ? 'disabled' : 'primary'" :disabled="isPartPay == 1 ? true : false" @click="chooseMerchandiser">选择销售</yz-btn>
            </template>
          </el-table-column>
        </el-table>
        <div class="margin-top-20">
          订单合计：￥{{ (discountPrice*rechargeNum).toFixed(2) }}
        </div>
      </div>
      <!-- <div v-if="isPartPay != 1" class="payStyleBox" style="margin-top: 20px;">
        <div class="pay-box-header">
          <strong>套餐信息</strong>
        </div>
        <div class="packageInfo">
          <div class="infoLeft">
            <div class="ll">
              <img v-if="packageInfo.vipCardImgUrl" :src="packageInfo.vipCardImgUrl+'?x-oss-process=image/resize,m_lfit,w_200'" />
              <img v-else src="static/images/card_bg.png" />
              <div class="discountInfo">
                <el-popover v-if="packageInfo.gradeList.length > 0 || packageInfo.activityInfo" placement="right" :trigger="Lib.pcOrMobile() === 'pc' ? 'hover' : 'click'" width="400px">
                  <div v-if="packageInfo.activityInfo" class="memberPriceDetails">
                    <h1><span>{{ packageInfo.activityInfo.activityName }}</span><positive-time :end-time="packageInfo.activityInfo.endDate"></positive-time></h1>
                    <div class="MH">
                      <h5><span>活动类型：</span><samp :style="Lib.getActivity(packageInfo.activityInfo.activityType,1)">{{ Lib.getActivity(packageInfo.activityInfo.activityType,2) }}</samp></h5>
                      <h5><span>参与人员：</span><samp class="themeFC">{{ packageInfo.activityInfo.participationType == 1 ? '全部通用' : '会员参与' }}</samp></h5>
                      <h5 v-if="packageInfo.activityInfo.activityType == 1">特价促销<samp class="themeFC">￥{{ packageInfo.activityInfo.activityPrice }}</samp><label v-if="packageInfo.activityInfo.promotionSaleCount*1 > 9999">，不限购</label><label v-else>，限购<samp class="themeFC">{{ packageInfo.activityInfo.promotionSaleCount }}</samp>件</label></h5>
                      <h5 v-else-if="packageInfo.activityInfo.activityType == 2"><span>活动周期：</span><samp>{{ getCycle(packageInfo.activityInfo.activityDays,packageInfo.activityInfo.cycleType) }}</samp></h5>
                      <h6 v-if="packageInfo.activityInfo.activityType == 2">
                        <span>优惠时间：</span>
                        <div class="sampLi">
                          <samp v-for="(a,b) in packageInfo.activityInfo.lookActivityDiscountTimeList" :key="b">{{ a.startTime }}~{{ a.endTime }}，打<b class="themeFC">{{ a.discount }}</b>折</samp>
                        </div>
                      </h6>
                      <div v-else-if="packageInfo.activityInfo.activityType == 3">
                        <h5 v-for="(c,d) in packageInfo.activityInfo.lookActivityGivenList" :key="d">{{ c.givenType == 1 ? '买满' : '每买满' }}<span class="themeFC">{{ c.buyNumber }}</span>件送<samp v-for="(x,y) in c.lookActivityGivenConditionList" :key="y">{{ x.activityGiftName }}*{{ x.giftCount }}{{ c.lookActivityGivenConditionList.length == (y+1) ? '' : '，' }}</samp></h5>
                      </div>
                      <div v-else-if="packageInfo.activityInfo.activityType == 4">
                        <h5 v-for="(c,d) in packageInfo.activityInfo.lookActivityGivenList" :key="d">购买指定商品满<span class="themeFC">{{ c.satisfyPrice }}</span>元送<samp v-for="(x,y) in c.lookActivityGivenConditionList" :key="y">{{ x.activityGiftName }}*{{ x.giftCount }}{{ c.lookActivityGivenConditionList.length == (y+1) ? '' : '，' }}</samp></h5>
                      </div>
                    </div>
                  </div>
                  <div v-if="packageInfo.gradeList.length > 0" class="memberPriceDetails">
                    <h1>会员价格</h1>
                    <div class="MH">
                      <p v-for="(v,n) in packageInfo.gradeList" :key="n">
                        <label>￥<samp>{{ Lib.getValue(1,(v.discountType == 1 ? v.number : (packageInfo.vipCardPrice * v.number/10).toFixed(2))) }}</samp>{{ Lib.getValue(2,(v.discountType == 1 ? v.number : (packageInfo.vipCardPrice * v.number/10).toFixed(2))) }}</label>
                        <span><i class="iconfont">&#xe612;</i>{{ v.gradeName }}</span>
                      </p>
                    </div>
                  </div>
                  <p slot="reference">
                    <span v-if="packageInfo.gradeList.length > 0">会员优惠</span>
                    <span v-if="packageInfo.activityInfo">{{ Lib.getActivity(packageInfo.activityInfo.activityType,2) }}</span>
                  </p>
                </el-popover>
              </div>
            </div>
            <div class="lr">
              <h1>{{ packageInfo.vipCardName }}</h1>
              <h2><span>折后价：</span><samp class="themeFC">￥{{ discountPrice }}</samp></h2>
              <h3>
                原价：￥{{ isPrice() }}<el-popover v-if="packageInfo.isWholesale == 0 && editOldPriceStatus != 1" placement="bottom-start" trigger="click">
                  <div class="editPrice">
                    <p>改原价</p>
                    <el-input v-model="editPrice" class="epInput" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" placeholder="请输入改价金额">
                      <template slot="prepend">￥</template>
                    </el-input>
                    <div class="epBtn">
                      <el-button @click="resetPrice">重置</el-button>
                      <el-button type="primary" @click="comfirmEditPrice">确定</el-button>
                    </div>
                  </div>
                  <i v-if="isPartPay != 1" slot="reference" class="iconfont" style="cursor: pointer;color: #BFCBD9;padding-left: 5px;">&#xe684;</i>
                </el-popover>
                <samp>优惠：-￥{{ calculationDiscountMoney(99) || '--' }}</samp>
              </h3>
              <div class="bPerson">
                <samp style="width: 80px;float: left;">优惠权益：</samp>
                <div v-if="packageInfo.qyCheckBox ? packageInfo.qyCheckBox.length > 0 ? true : false : false" class="themeFC" style="cursor: pointer;" @click="isPartPay == 1 ? '' : chooseRI(packageInfo)">{{ getChooseQyinfo(packageInfo) }}</div>
                <yz-btn v-else size="mini" :type="isPartPay == 1 ? 'disabled' : 'primary'" :disabled="isPartPay == 1 ? true : false" @click="isPartPay == 1 ? '' : chooseRI(packageInfo)">选择优惠权益</yz-btn>
              </div>
              <div class="bNumber">
                <samp>出售数量：</samp>
                <el-input-number v-model.trim="rechargeNum" :disabled="isPartPay == 1 ? true : false" class="btnOne" size="mini" :min="1" :max="9999999"></el-input-number>
              </div>
              <div class="bPerson">
                <samp style="width: 80px;float: left;">销售人员：</samp>
                <div v-if="percentage4PackageList.length > 0" class="themeFC" style="cursor: pointer;" @click="isPartPay == 1 ? '' : chooseMerchandiser()">
                  <span v-for="(item,index) in percentage4PackageList" :key="index">{{ item.technicianName }}{{ percentage4PackageList.length == (index+1) ? '' : '，' }}</span>
                </div>
                <yz-btn v-else size="mini" :type="isPartPay == 1 ? 'disabled' : 'primary'" :disabled="isPartPay == 1 ? true : false" @click="chooseMerchandiser">选择销售</yz-btn>
              </div>
              <div v-if="buyGiftList.length > 0" class="bNumber">
                买赠赠品：<span v-for="(v,n) in buyGiftList" :key="n">{{ v.activityGiftName }}*{{ v.buyGiftCount }}{{ buyGiftList.length == (n+1) ? '' : '、' }}</span>
              </div>
              <div v-if="fullGiftList.length > 0" class="bNumber">
                满赠赠品：<span v-for="(v,n) in fullGiftList" :key="n">{{ v.activityGiftName }}*{{ v.buyGiftCount }}{{ fullGiftList.length == (n+1) ? '' : '、' }}</span>
              </div>
            </div>
          </div>
          <div class="infoRight">
            <h2>
              <span>{{ packageInfo.validType == 1 ? '有效时间：' : packageInfo.validType == 2 ? '有效期限：' : '有效天数：' }}{{ packageInfo.validType == 1 ? (packageInfo.startTime+'至'+ packageInfo.endTime) : packageInfo.validType == 2 ? '永久有效' : ((packageInfo.validTime ? packageInfo.validTime : '0')+'天') }}</span>
              <label></label>
            </h2>
            <p>
              套餐类型：{{ countLimitType }}<span v-show="countLimitType == '通用次数'">(<span style="color:#fd5c8c">{{ packageInfo.beUsedCount }}</span>{{ '次' }})</span>
            </p>
            <p>
              套餐内容：
              <span v-show="packageInfo.vipCardItemInfoDto.length >0">项目X{{ packageInfo.vipCardItemInfoDto.length }}&emsp;</span>
              <span v-show="packageInfo.basePackageProductList.length >0">产品X{{ packageInfo.basePackageProductList.length }}</span>
              <el-popover placement="right" trigger="hover">
                <div v-if="packageInfo.vipCardItemInfoDto.length" class="Ncontent">
                  <div class="Ncontent_top">项目信息</div>
                  <div v-for="(item, index) in packageInfo.vipCardItemInfoDto" :key="index" class="Ncontent_box">
                    {{ item.dictItemName }}
                    <span v-show="countLimitType != '通用次数'">（次数：<samp style="color:#fd5c8c">{{ countLimitType == '有限次数' ?item.count :'无限' }}</samp>）</span>
                  </div>
                </div>
                <div v-if="packageInfo.basePackageProductList.length" class="Ncontent">
                  <div class="Ncontent_top">产品信息</div>
                  <div v-for="(item, index) in packageInfo.basePackageProductList" :key="index" class="Ncontent_box">
                    {{ item.productName }}
                    <span v-show="countLimitType != '通用次数'">（次数：<samp style="color:#fd5c8c">{{ countLimitType == '有限次数' ?item.productCount :'无限' }}</samp>）</span>
                  </div>
                </div>
                <i slot="reference" class="iconfont" style="color:#d2d2d2;font-size:14px;margin-left:5px;">&#xe71a;</i>
              </el-popover>
            </p>
            <p>
              可用门店：{{ shopValue }}等<samp class="themeFC">{{ packageInfo.useStoreList.length }}</samp>个门店<el-popover placement="right" trigger="hover">
                <div style="padding: 12px;">
                  <p v-for="(list,num) in packageInfo.useStoreList" :key="num">{{ list.name }}</p>
                </div>
                <i slot="reference" class="iconfont" style="color:#d2d2d2;font-size:14px;margin-left:5px;">&#xe71a;</i>
              </el-popover>
            </p>
          </div>
        </div>
      </div> -->
      <div v-if="!isPartPay && packageInfo.isWholesale == 0">
        <div v-if="(memberInfo && memberInfo.fansCurrency && memberInfo.fansCurrency != 0) || (memberInfo && memberInfo.integral && memberInfo.integral != 0) || memberInfo.cardList || memberInfo.appointCardList" class="payStyleBox" style="margin-top: 20px;">
          <div class="pay-box-header">
            <strong>选择抵扣优惠</strong>
          </div>
          <div class="cardUl" style="padding: 10px 30px 20px;position: relative;">
            <yz-coupon ref="childConpon" :member-msg="memberInfo" :total-money="isPrice()*rechargeNum+''" :product-sales="{}" :service-items="{}" :package-buy="calculationDiscountMoney(99)*1" @getConponMsg="getConponMsg"></yz-coupon>
          </div>
          <div></div>
        </div>
      </div>
      <div class="payStyleBox" style="margin-top: 20px;">
        <div class="pay-box-header">
          <strong>结算信息</strong>
        </div>
        <div class="cardUl" style="padding: 10px 30px 20px;">
          <yz-settlement-msg :edit-price-val="isPartPay" :change-coupon="changeCoupon" :settlement-msg="settlementMsg" :customer-msg="customerMsg" :change-discount-money="calculationDiscountMoney(1)" :member-discount-money="calculationDiscountMoney(2)" :order-change-money="packageInfo.orderChangeMoney ? packageInfo.orderChangeMoney*1 : 0" :part-pay-total="partPayTotal" :init-amount="(isPrice()*rechargeNum+buyGiftDiscount()+fullGiftDiscount()).toFixed(2)*1" :wholesale-price="calculationDiscountMoney(3)" :activity-price-list="calculationDiscountMoney(4)" :package-buy="calculationDiscountMoney(99)*1" :discount-amount="packageInfo.discountAmount ? (packageInfo.discountAmount*1).toFixed(2) : '0.00'" :buy-gift-discount="buyGiftDiscount()" :full-gift-discount="fullGiftDiscount()" @getSettlementMsg="getSettlementMsg"></yz-settlement-msg>
        </div>
      </div>
      <yz-pay-method ref="payMethods" :edit-money-val="editMoneyVal" :pay-methods="payMethods" :settlement-msg="settlementMsg" :on-account-auth="onAccountAuth*1" :client-vip-card-id="packageInfo.clientVipCardId+''" :is-part-pay="isPartPay" :customer-msg="customerMsg" :wholesale-price="calculationDiscountMoney(3)" @getPayMethodsMsg="getPayMethodsMsg" @getEDPS="editDiscountPriceStatusChange" @getEDYPS="editOldPriceStatusChange"></yz-pay-method>
      <div class="commonFooterBtn" style="text-align: left;margin: 40px 0;">
        <el-button type="primary" :loading="receivablesBtn" @click="checkReceivables">结算</el-button>
      </div>

      <drawer title="选择优惠权益" status="service" :display.sync="allDisplay">
        <div class="discountRI">
          <h1>{{ packageInfo.vipCardName }}</h1>
          <h2 style="margin-bottom: 10px;">单价：￥{{ isPrice() }}</h2>
          <el-checkbox-group v-model="packageRI" size="small">
            <div v-for="(v,n) in chooseInfoRI.qyList" :key="n">
              <el-input-number v-model="v.qyCount" size="mini" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" :disabled="v.type == 2" :min="1" :max="9999" step-strictly @keyup.enter.native="Lib.keyboardBlur" @change="qyChange(v,n,1)"></el-input-number>
              <el-checkbox :label="v.type" border :disabled="checkDisabled(v)" @change="qyChange(v,n,2)">
                <h3>{{ v.title }}</h3>
                <h4 v-if="v.title !== '使用改价优惠'">{{ v.info }}</h4>
                <div v-else class="editPriceRI">
                  <p><span>项目单价</span><i style="height: 12px;line-height: 12px;"></i><samp>折扣比例</samp></p>
                  <p>
                    <span>
                      <el-input v-model="v.rightsPrice" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" size="medium" @change="changePrice(1,v)">
                        <template slot="append">元</template>
                      </el-input>
                    </span>
                    <i class="el-icon-sort"></i>
                    <samp>
                      <el-input v-model="v.percentage" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" size="medium" @change="changePrice(2,v)">
                        <template slot="append">%</template>
                      </el-input>
                    </samp>
                  </p>
                </div>
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
        <div class="footRI">
          <div class="frBtr">
            <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
              <div slot="content">
                <p style="width: 350px;">{{ getChooseQyinfo(chooseInfoRI) }}</p>
              </div>
              <p @mouseover="tooltipStatus = Lib.textShow($event)">已使用优惠权益：{{ getChooseQyinfo(chooseInfoRI) }}</p>
            </el-tooltip>
            <h6 @click="determineUse()">确定使用</h6>
          </div>
        </div>
      </drawer>

      <el-dialog class="merchandiserDialog chooseServiceCss" width="1000px" title="销售员工列表" :visible.sync="packageDialog" :append-to-body="true">
        <div class="el-message-box__content" style="height: 606px;padding: 0;">
          <div class="dialog_header">
            <el-input v-model="searchMerchandiserVal" class="width_242" placeholder="请输入员工姓名/工号" style="float:left;" @keyup.enter.native="searchMerchandiser">
              <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="searchMerchandiser"></i>
            </el-input>
            <p>
              套餐名称：{{ packageInfo.vipCardName }}
              <el-tooltip effect="light" placement="right-start">
                <div slot="content">
                  <p class="tooltip-p">提成点和提成金额展示“--”有三种情况：</p>
                  <p class="tooltip-p">1.该套餐在后台没有设置任何提成</p>
                  <p class="tooltip-p">2.该套餐在后台仅设置了销售达标提成</p>
                  <p class="tooltip-p">3.该套餐在后台仅设置了高级提成</p>
                </div>
                <i class="iconfont iconCdTwo">&#xe71a;</i>
              </el-tooltip>
            </p>
            <h6>
              <span>合计：</span>
              <label>￥{{ (discountPrice*rechargeNum).toFixed(2) }}</label>
              <samp>￥{{ isPrice()*rechargeNum }}</samp>
              <el-tooltip effect="light" content="合计=折后价/原价×数量" placement="right">
                <i class="iconfont iconCdTwo">&#xe71a;</i>
              </el-tooltip>
            </h6>
          </div>
          <div class="commonTable tablePointer" style="height: 528px;border: 1px solid #eee;width: 280px;float: left;overflow: hidden;">
            <el-tabs v-if="brandInfo.cardOpen == 1" v-model="activeName" class="brandList" @tab-click="getStaffIdListData">
              <el-tab-pane v-for="(v,n) in brandInfo.cards" :key="n" :label="v.cardName" :name="v.id+''">
                <span v-if="v.cardName == '未分配'" slot="label">{{ v.cardName }}
                  <el-tooltip class="item" effect="light" content="展示后台未分配轮牌的销售" placement="right">
                    <i class="el-icon-warning"></i>
                  </el-tooltip>
                </span>
              </el-tab-pane>
            </el-tabs>
            <el-table ref="packageTCTable" tooltip-effect="light" :data="searchPackageList.lookTechnicians" class="newSelect" height="530" @select="selectChoosePackageEvent" @row-click="choosePackageEvent">
              <el-table-column :class-name="'ht_23'" type="selection" width="45" :selectable="checkSelectable"></el-table-column>
              <el-table-column prop="number" label="工号" width="100">
                <template slot-scope="scope">
                  <el-popover v-if="menusList.find(data => data.iDenTi === 'beauty-1-lp')" placement="bottom-start" trigger="hover">
                    <p style="padding: 10px;">{{ scope.row.state == 1 ? '服务中' : scope.row.state == 2 ? '预约将到' : scope.row.state == 3 ? '有事暂离' : scope.row.state == 4 ? '请假' : scope.row.state == 5 ? '休假' : scope.row.state == 6 ? scope.row.message : '空闲中' }}</p>
                    <label slot="reference" :class="'stafIcon ' + (scope.row.state == 1 ? 'sifour' : scope.row.state == 2 ? 'sitwo' : scope.row.state == 3 ? 'sithree' : scope.row.state == 4 ? 'sifive' : scope.row.state == 5 ? 'sifive' : scope.row.state == 6 ? 'sifive' : 'sione')"></label>
                  </el-popover>
                  <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
                    <div slot="content">
                      <p>{{ scope.row.number }}</p>
                    </div>
                    <span class="commonTableShow" style="width: 60px;padding-left: 5px;" @mouseover="tooltipStatus = Lib.textShow($event)">{{ scope.row.number || '--' }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="technicianName" label="姓名" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
          </div>
          <div class="commonTable" style="height: 528px;border: 1px solid #eee;width: 630px;float: right;">
            <el-table tooltip-effect="light" class="merchandiserTable" :data="choosePackageList" height="530">
              <el-table-column label="员工" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.number?scope.row.number+'/':'' }}{{ scope.row.technicianName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="业绩占比">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.result" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '')" size="mini" style="width: 100px;" :disabled="Lib.getPercentage()" placeholder="请输入业绩占比" @change="resultChange(scope.$index,3)">
                    <template slot="append">%</template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column label="提成点">
                <template slot-scope="scope">
                  <div v-if="scope.row.isExit == 1">
                    <el-input v-if="scope.row.levelType == 0" v-model="scope.row.percentage" size="mini" style="width: 100px;" placeholder="" :disabled="Lib.getPercentage()" @change="resultChange(scope.$index,33)">
                      <template slot="append">{{ scope.row.percentageType == 1?'元':'%' }}</template>
                    </el-input>
                    <span v-else>--</span>
                  </div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot="header" slot-scope="scope">
                  <span>{{ scope ? '' : '' }}提成金额</span>
                  <el-tooltip effect="light" placement="bottom">
                    <div slot="content">
                      <p class="tooltip-p">1、比例提成：提成金额=业绩占比×提成点×小计</p>
                      <p class="tooltip-p">2、固定提成：提成金额=业绩占比×提成点×套餐数量</p>
                    </div>
                    <i class="iconfont iconCdTwo">&#xe71a;</i>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <div v-if="scope.row.isExit == 1">
                    <span v-if="scope.row.levelType == 0">{{ scope.row.percentageType == 1 ? (scope.row.percentage*scope.row.result*rechargeNum/100).toFixed(2) : (scope.row.percentage*scope.row.result*discountPrice*rechargeNum/10000).toFixed(2) }}</span>
                    <span v-else>--</span>
                  </div>
                  <div v-else>--</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="newFootCss">
          <!-- <div class="newFootCode">
                        <span class="newPrice">提成总价：
                            <small>￥{{packagePercentageTotal}}</small>
                        </span>
                    </div> -->
          <div class="newFootBtn">
            <el-button type="primary" @click="comfirmAddPackage">确 定</el-button>
            <el-button @click="packageDialog = false">取 消</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getMemberCardMsg,
  getBeautyPackageOne,
  postCardShopping,
  postCardPurchase,
  getOrderCode,
  getPercentageSkin, // （4.5.0）获取全局提成设置
  getPackagePartPayMsg, // (5.4)查询套餐部分支付还款页面信息
  erpTechnicianCardByMainId, // 5.7erp选择统称，选择销售的轮牌列表
  getStaffBrandList, // 5.7（服务开单或修改订单）根据项目、产品、套餐id获取统称-员工列表
} from '../api';
import YzCoupon from '../../orderSettlement/template/coupon';
import YzSettlementMsg from './settlementMsg';
import YzPayMethod from './payMethod';
// import PositiveTime from '../../serviceBilling/components/positiveTime';
import drawer from '../../../../publicVue/drawer';
import YzConsumptionList from '../../orderSettlement/template/consumptionList';

export default {
  components: {
    YzCoupon,
    YzSettlementMsg,
    YzPayMethod,
    // PositiveTime,
    drawer,
    YzConsumptionList
  },
  data() {
    return {
      searchVal: '', // 搜索会员的值
      memberInfo: {
        headImgUrl: '', // 会员头像地址
        nickName: '', // 会员名称
        receiveDate: '', // 创建时间
        fansCurrency: '', // 粉币数量
        money: '', // 余额
        cardNo: '', // 会员卡号
        integral: '', // 积分
        phone: '' // 会员手机
      },
      oldVipCardPrice: '', // 套餐价格--原价旧价格
      rechargeNum: 1, // 套餐出售数量
      countLimitType: '', // 套餐多样性类型
      selectCouponIndex: -1, // 选择的优惠券
      hasSelectNumber: 1, // 优惠券选择数量
      packageDialog: false, // 选择开单员--弹出窗口
      searchMerchandiserVal: '', // 开单员列表--搜索值
      searchPackageList: [], // 开单员列表
      pageNum: 1, // 开单员列表--页码
      receivablesBtn: false, // 结算按钮加载效果
      payamount: '0',
      returnPayMoney: '0',

      dialogProductName: '',
      dialogTotal: 0,
      choosePackageList: [],
      tooltipStatus: false, // 气泡显示
      settlementMsg: '',

      scaleStan: 0, // 全局提成  0为原价算提成   1为折后价算提成
      resultType: 1, // 业绩占比   1为整单业绩  2为自动平分
      percentage4PackageList: [], // 选择的提成员工数据
      packagePercentageTotal: '0', // 套餐提成总价
      isPercentage: 0, // 是否有可选销售  0没有  1有

      // 5.4
      editPrice: '', // 改价的值
      changeCoupon: false,
      isPartPay: 0, // （0：不是部分支付订单，1：部分支付订单,2:部分支付还款订单）
      editMoneyVal: 0, // 改价的金额
      payMethods: {
        orderId: '',
        money: '',
        discountMoney: '',
        cardNo: '',
        orderCode: '',
        ctName: ''
      },
      onAccountAuth: 0,
      payType: [],
      editDiscountPriceStatus: '', // 改折后价状态
      editOldPriceStatus: '', // 6.5改原价状态
      partPayTotal: 0, // 部分支付应还金额
      partPayOrderId: '', // 部分支付订单ID
      resultAmount: 0, // 最后支付金额
      newPayamount: 0, // 现金支付客户支付的金额
      customerMsg: {},
      loading: false,
      // 5.7
      brandInfo: {},
      activeName: '',
      // 6.4
      oldOrderCode: '', // 原始订单号
      // 6.5
      discountPrice: '', // 折后价--选择优惠权益之后，折算之后得到的价格
      allDisplay: false, // 选择优惠权益弹窗
      packageRI: [], // 勾选的权益列表值
      chooseInfoRI: {
        qyList: []
      }, // 优惠权益--选择的
      // 6.5变动
      packageInfo: {
        gradeList: [],
        vipCardItemInfoDto: [],
        basePackageProductList: [],
        useStoreList: [],
        qyList: []
      },
      shopValue: window.sessionStorage.shopValue,
      buyGiftList: [],
      fullGiftList: [],
      menusList: JSON.parse(sessionStorage.getItem('menusList')),
      // 6.7
      serviceNames: [],
      vipCard: {},
      consumptionList: [],
    };
  },
  watch: {
    payamount() {
      this.changePayamount();
    },
    rechargeNum() {
      setTimeout(() => {
        if (this.packageInfo.limitPurchase * 1 > 0 && (this.rechargeNum * 1 > (this.packageInfo.limitPurchase * 1 - this.packageInfo.alreadyPurchase * 1))) {
          this.$message({ type: 'warning', message: (`${this.packageInfo.vipCardName}限购${this.packageInfo.limitPurchase}次，该客户已购买过${this.packageInfo.alreadyPurchase}次，已达上限`) });
          this.rechargeNum = this.packageInfo.limitPurchase * 1 - this.packageInfo.alreadyPurchase * 1;
          return;
        }
        if ((!this.rechargeNum) || (this.rechargeNum === undefined)) this.rechargeNum = 1;
        this.autoChooseRights();
      }, 0);
    },
  },
  activated() {
    Object.assign(this.$data, this.$options.data());
    this.isPartPay = this.$route.params.partPay || 0;
    this.partPayOrderId = this.$route.params.id || '';
    if (this.isPartPay == 1) {
      this.getPackagePartPayMsg();
      return;
    }
    this.editMoneyVal = 0;
    this.settlementMsg = window.JSON.stringify({
      totalMoney: window.parseFloat(this.payamount * 1).toFixed(2),
      resulteMoney: window.parseFloat(this.payamount * 1).toFixed(2),
      others: {
        couponMsg: {
          money: 0,
          num: 0,
          cardId: ''
        },
        fenBiMsg: {
          money: 0,
          num: 0
        },
        jifenMsg: {
          money: 0,
          num: 0
        },
        resulteMoney: window.parseFloat(this.payamount * 1).toFixed(2),
      }
    });
    this.selectCouponIndex = -1;
    this.rechargeNum = 1;
    this.searchVal = window.sessionStorage.rechargePhone;
    this.phoneSearch();
  },
  deactivated() {
    this.$store.commit('deleteTabs', 'stage-recharge');
    this.rechargeNum = 1;
  },
  methods: {
    refreshData() {
      this.phoneSearch();
    },
    isPrice() {
      if (this.packageInfo.isWholesale == 1) {
        return this.packageInfo.wholesalePrice;
      }
      return this.packageInfo.vipCardPrice;
    },
    // 计算买赠的优惠价格
    buyGiftDiscount() {
      let total = 0;
      this.buyGiftList.forEach((a) => {
        total += a.activityGiftPrice * a.giftCount;
      });
      return total;
    },
    // 计算满赠的优惠价格
    fullGiftDiscount() {
      let total = 0;
      this.fullGiftList.forEach((a) => {
        total += a.activityGiftPrice * a.giftCount;
      });
      return total;
    },
    // 获取买赠的赠品列表
    getBuyGiftList() {
      this.buyGiftList = [];
      this.fullGiftList = [];
      if (this.packageInfo.hasActivity == 1) {
        if (this.packageInfo.activityInfo.activityType == 3) {
          let max = 0;
          let maxIndex = 0;
          this.packageInfo.activityInfo.lookActivityGivenList.forEach((b, n) => {
            if (this.rechargeNum * 1 >= b.buyNumber && b.buyNumber * 1 > max) {
              max = b.buyNumber;
              maxIndex = n;
            }
          });
          const val = this.packageInfo.activityInfo.lookActivityGivenList[maxIndex];
          if (val.givenType == 1 && this.rechargeNum >= val.buyNumber) {
            val.lookActivityGivenConditionList.forEach((c) => {
              c.buyGiftCount = c.giftCount;
              this.buyGiftList.push(c);
            });
          } else if (val.givenType == 2 && this.rechargeNum >= val.buyNumber) {
            val.lookActivityGivenConditionList.forEach((c) => {
              // eslint-disable-next-line operator-assignment
              c.buyGiftCount = Math.floor(this.rechargeNum / val.buyNumber) * c.giftCount;
              this.buyGiftList.push(c);
            });
          }
        }
        if (this.packageInfo.activityInfo.activityType == 4) {
          let max = 0;
          let maxIndex = 0;
          const total = (this.isPrice() * this.rechargeNum - this.calculationDiscountMoney(99) * 1).toFixed(2);
          this.packageInfo.activityInfo.lookActivityGivenList.forEach((b, n) => {
            if (total * 1 >= b.satisfyPrice && b.satisfyPrice * 1 > max) {
              max = b.satisfyPrice;
              maxIndex = n;
            }
          });
          const val = this.packageInfo.activityInfo.lookActivityGivenList[maxIndex];
          if (total * 1 >= val.satisfyPrice) {
            val.lookActivityGivenConditionList.forEach((c) => {
              c.buyGiftCount = c.giftCount;
              this.fullGiftList.push(c);
            });
          }
        }
      }
    },
    // 获取周期展示
    getCycle(val, status) {
      const arr = val.split(',');
      const newArr = arr.sort();
      const lastArr = [];
      newArr.forEach((v) => {
        if (v) lastArr.push(v);
      });
      let cycleArr = '';
      if (status == 1) {
        newArr.forEach((a, m) => {
          if (a == 1) cycleArr += `周一${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 2) cycleArr += `周二${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 3) cycleArr += `周三${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 4) cycleArr += `周四${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 5) cycleArr += `周五${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 6) cycleArr += `周六${newArr.length == (m + 1) ? '' : '、'}`;
          else if (a == 7) cycleArr += `周日${newArr.length == (m + 1) ? '' : '、'}`;
        });
      } else {
        newArr.forEach((b, n) => {
          if (n == 0) cycleArr += '每月';
          if (b) cycleArr += `${b}日${newArr.length == (n + 1) ? '' : '、'}`;
        });
      }
      return cycleArr;
    },
    // 已使用优惠权益信息
    getChooseQyinfo(obj) {
      let strings = '';
      obj.qyList = obj.qyList || [];
      obj.qyList.forEach((a) => {
        if (a.ischeck == true) {
          if (a.type == 1) {
            strings += '经销商等级权益，';
          } else if (a.type == 2 || a.type == 3 || a.type == 4 || a.type == 5) {
            strings += `${a.type == 2 ? '特价促销' : a.type == 3 ? '定时打折' : a.type == 4 ? '会员优惠' : '改价优惠'}-￥${((this.isPrice() - a.rightsPrice) * a.qyCount).toFixed(2)}，`;
          }
        }
      });
      const arr = strings.split('，');
      let newString = '';
      arr.forEach((a, m) => {
        if (a) {
          newString += a + (arr.length == (m + 2) ? '' : '，');
        }
      });
      return newString || '不使用优惠权益';
    },
    // 勾选判断
    checkDisabled(v) {
      const obj = this.chooseInfoRI;
      if ((obj.chooseCount == this.rechargeNum || this.packageRI.length == 2) && v.ischeck == false) {
        return true;
      }
      if (obj.qyList.find((a) => a.type == 2)) {
        if (this.packageRI.find((a) => a == 4)) {
          return !!(v.type == 5 || v.type == 99);
        } if (this.packageRI.find((a) => a == 5)) {
          return !!(v.type == 4 || v.type == 99);
        } if (this.packageRI.find((a) => a == 99)) {
          return !!(v.type == 4 || v.type == 5);
        }
      }
    },
    // 勾选赋值
    checkValue(val) {
      this.packageRI = [val];
      this.chooseInfoRI.qyList.forEach((b) => {
        if (b.type == val) {
          b.qyCount = this.rechargeNum;
          b.ischeck = true;
        } else {
          b.ischeck = false;
        }
      });
    },
    // 选择/改变优惠权益
    qyChange(vObj, index, status) {
      const obj = this.chooseInfoRI;
      if (status == 2) {
      // 经销商判断
        if (vObj.type == 1 && this.packageRI.find((a) => a == 1)) {
          this.checkValue(1);
        }
        // 特价判断
        if (vObj.type == 2 && this.packageRI.find((a) => a == 2)) {
          if (this.rechargeNum * 1 >= vObj.promotionSaleCount * 1) {
            obj.qyList[index].qyCount = vObj.promotionSaleCount;
          } else {
            this.checkValue(2);
          }
        }
        // 定折判断
        if (vObj.type == 3 && this.packageRI.find((a) => a == 3)) {
          this.checkValue(3);
        }
        // 会员优惠判断
        if (vObj.type == 4 && this.packageRI.find((a) => a == 4) && !obj.qyList.find((a) => a.type == 2)) {
          this.checkValue(4);
        }
        // 改价判断
        if (vObj.type == 5 && this.packageRI.find((a) => a == 5) && !obj.qyList.find((a) => a.type == 2)) {
          this.checkValue(5);
        }
        // 不使用优惠判断
        if (vObj.type == 99 && this.packageRI.find((a) => a == 99) && !obj.qyList.find((a) => a.type == 2)) {
          this.checkValue(99);
        }
      }
      let totalNumOne = 0;
      // 常规判断
      obj.qyList.forEach((c) => {
        c.ischeck = false;
      });
      this.packageRI.forEach((a) => {
        obj.qyList.forEach((b) => {
          if (a == b.type) {
            totalNumOne += b.qyCount;
            b.ischeck = true;
          }
        });
      });
      if (totalNumOne > this.rechargeNum * 1) {
        this.$message('超过可选数量');
        let totalNumTwo = 0;
        if (status == 1) {
          setTimeout(() => {
            obj.qyList[index].qyCount = obj.qyList[index].qyCount * 1 - 1;
            this.packageRI.forEach((a) => {
              obj.qyList.forEach((b) => {
                if (a == b.type) {
                  totalNumTwo += b.qyCount;
                  b.ischeck = true;
                }
              });
            });
            obj.chooseCount = totalNumTwo;
            this.$forceUpdate();
          }, 10);
        } else {
          this.packageRI.forEach((e, m) => {
            if (e == obj.qyList[index].type) {
              obj.qyList[index].ischeck = false;
              this.packageRI.splice(m, 1);
            }
          });
          obj.qyList.forEach((c) => {
            c.ischeck = false;
          });
          setTimeout(() => {
            this.packageRI.forEach((a) => {
              obj.qyList.forEach((b) => {
                if (a == b.type) {
                  totalNumTwo += b.qyCount;
                  b.ischeck = true;
                }
              });
            });
            obj.chooseCount = totalNumTwo;
          }, 10);
        }
      } else {
        obj.chooseCount = totalNumOne;
      }
    },
    // 选择/改变优惠权益
    changePrice(status, obj) {
      if (status == 1) {
        if (obj.rightsPrice * 1 > obj.price * 1) obj.rightsPrice = JSON.parse(JSON.stringify(obj.price));
        obj.percentage = (obj.rightsPrice / obj.price * 100).toFixed(2);
      } else {
        if (obj.percentage * 1 > 100) obj.percentage = 100;
        if (obj.percentage * 1 < 0) obj.percentage = 0;
        obj.rightsPrice = (obj.percentage * obj.price / 100).toFixed(2);
      }
    },
    // 确定使用权益
    determineUse() {
      const obj = this.chooseInfoRI;
      obj.saleDetails = [];
      obj.qyCheckBox = JSON.parse(JSON.stringify(this.packageRI));
      obj.isWholesale = 0;
      obj.qyList.forEach((a) => {
        let num = 0;
        this.packageRI.forEach((b) => {
          if (a.type == b) {
            num = 1;
          }
        });
        if (num == 1) {
          const nobj = {};
          nobj.memberDiscount = a.memberDiscount;
          nobj.memberPrice = a.memberPrice;
          nobj.originalPrice = a.originalPrice;
          nobj.qyCount = a.qyCount;
          nobj.type = a.type;
          if (a.type == 1) {
            nobj.isWholesale = 1;
            nobj.wholesalePrice = a.wholesalePrice;
            nobj.rightsPrice = a.wholesalePrice;
          } else if (a.type == 2 || a.type == 3) {
            nobj.activityId = obj.activityInfo.activityId;
            nobj.activityType = obj.activityInfo.activityType;
            nobj.rightsPrice = obj.activityInfo.activityPrice;
          } else if (a.type == 4) {
            nobj.twoDiscountType = obj.discountType;
            nobj.twoPrice = obj.memberPrice;
            nobj.rightsPrice = obj.memberPrice;
          } else if (a.type == 5) {
            nobj.isChangePrice = 1;
            nobj.rightsPrice = a.rightsPrice;
          } else if (a.type == 99) {
            nobj.rightsPrice = obj.price;
          }
          obj.saleDetails.push(nobj);
        }
      });
      let total = 0;
      obj.saleDetails.forEach((a) => {
        total += a.qyCount;
      });
      if ((this.rechargeNum * 1 > total) && window.location.href.indexOf('/stage/recharge') > -1) {
        this.$message('数量不对，请检查清楚');
        return;
      }
      obj.qyList.forEach((a) => {
        if (a.ischeck && a.type == 1) {
          obj.isWholesale = 1;
        }
      });
      this.packageInfo = JSON.parse(JSON.stringify(obj));
      this.allDisplay = false;
      this.computingPrice();
      this.discountPrice = ((this.isPrice() * this.rechargeNum - this.calculationDiscountMoney(99) * 1) / this.rechargeNum * 1).toFixed(2);
    },
    // 获取权益列表
    chooseRI(obj, status) {
      if (obj.qyList) {
        if (obj.qyList.length > 0) {
          this.allDisplay = true;
          setTimeout(() => {
            this.packageRI = obj.qyCheckBox || [];
            obj.qyList.forEach((c) => {
              c.ischeck = false;
            });
            let totalNumOne = 0;
            this.packageRI.forEach((a) => {
              obj.qyList.forEach((b) => {
                if (a == b.type) {
                  totalNumOne += b.qyCount;
                  b.ischeck = true;
                }
              });
            });
            obj.chooseCount = totalNumOne;
          }, 10);
          return;
        }
      }
      obj.qyList = [];
      if (obj.isWholesale == 1) {
        obj.qyList.push({
          isWholesale: 1,
          wholesalePrice: obj.wholesalePrice,
          originalPrice: obj.price,
          qyCount: 1,
          info: '享受经销商等级权益价格',
          price: obj.price,
          rightsPrice: obj.wholesalePrice,
          title: '使用经销商权益',
          type: 1,
          memberDiscount: obj.memberDiscount,
          memberPrice: obj.memberPrice,
          ischeck: false,
        });
      }
      if (obj.hasActivity == 1) {
        if (obj.activityInfo.activityType == 1) {
          obj.qyList.push({
            activityId: obj.activityInfo.activityId,
            activityType: obj.activityInfo.activityType,
            title: '特价促销活动',
            info: `特价促销价格${obj.activityInfo.activityPrice}元`,
            originalPrice: obj.price,
            promotionSaleCount: this.packageInfo.activityInfo.promotionSaleCount,
            qyCount: 1,
            price: obj.price,
            rightsPrice: obj.activityInfo.activityPrice,
            type: 2,
            memberDiscount: obj.memberDiscount,
            memberPrice: obj.memberPrice,
            ischeck: false,
          });
        } else if (obj.activityInfo.activityType == 2) {
          obj.qyList.push({
            activityId: obj.activityInfo.activityId,
            activityType: obj.activityInfo.activityType,
            title: '定时打折活动',
            info: `定时打${obj.activityInfo.discount}折`,
            originalPrice: obj.price,
            qyCount: 1,
            price: obj.price,
            rightsPrice: obj.activityInfo.activityPrice,
            type: 3,
            memberDiscount: obj.memberDiscount,
            memberPrice: obj.memberPrice,
            ischeck: false,
          });
        }
      }
      if (this.memberInfo.cardNo) {
        obj.qyList.push({
          twoDiscountType: obj.discountType,
          twoPrice: obj.memberPrice,
          title: '会员折扣优惠',
          info: `享受${obj.discountType == 1 ? (`${obj.memberPrice}元`) : (`${obj.memberDiscount}折`)}优惠`,
          originalPrice: obj.price,
          qyCount: 1,
          price: obj.price,
          rightsPrice: obj.memberPrice,
          type: 4,
          memberDiscount: obj.memberDiscount,
          memberPrice: obj.memberPrice,
          ischeck: false,
        });
      }
      if (this.editDiscountPriceStatus != 1) {
        obj.qyList.push({
          isChangePrice: 0,
          percentage: 100,
          title: '使用改价优惠',
          info: '',
          originalPrice: obj.price,
          qyCount: 1,
          price: obj.price,
          rightsPrice: obj.price,
          type: 5,
          memberDiscount: obj.memberDiscount,
          memberPrice: obj.memberPrice,
          ischeck: false,
        });
      }
      obj.qyList.push({
        title: '不使用优惠权益',
        info: '选择后不享受任何优惠',
        originalPrice: obj.price,
        qyCount: 1,
        price: obj.price,
        rightsPrice: obj.price,
        type: 99,
        memberDiscount: obj.memberDiscount,
        memberPrice: obj.memberPrice,
        ischeck: false,
      });
      this.chooseInfoRI = JSON.parse(JSON.stringify(obj));
      if (!status) {
        this.allDisplay = true;
        setTimeout(() => {
          this.packageRI = obj.qyCheckBox || [];
        }, 10);
      } else {
        this.autoChooseRights();
      }
    },
    // 自动选择权益
    autoChooseRights() {
      const obj = this.chooseInfoRI;
      if (this.packageRI.length == 1 && obj.qyList.find((a) => (a.type == 2 && a.ischeck))) {
        let psCount = 0;
        let psIndex = 0;
        obj.qyList.forEach((a, m) => {
          if (a.ischeck) {
            psCount = JSON.parse(JSON.stringify(a.promotionSaleCount)) * 1;
            psIndex = JSON.parse(JSON.stringify(m)) * 1;
          }
        });
        if (this.rechargeNum * 1 > psCount * 1) {
          obj.qyList[psIndex].qyCount = psCount;
          obj.qyList[psIndex + 1].qyCount = this.rechargeNum * 1 - psCount * 1;
          obj.qyList[psIndex + 1].ischeck = true;
          this.packageRI.push(obj.qyList[psIndex + 1].type);
        } else {
          obj.qyList[psIndex].qyCount = this.rechargeNum * 1;
        }
      } else if (this.packageRI.length == 1 && !obj.qyList.find((a) => (a.type == 2 && a.ischeck))) {
        obj.qyList.forEach((a) => {
          if (a.ischeck) {
            a.qyCount = this.rechargeNum;
          }
        });
      } else if (this.packageRI.length == 2) {
        let psCount = 0;
        let psIndex = 0;
        let nextIndex = 0;
        obj.qyList.forEach((a, m) => {
          if (a.type == 2) {
            psCount = JSON.parse(JSON.stringify(a.promotionSaleCount)) * 1;
            psIndex = JSON.parse(JSON.stringify(m)) * 1;
          }
          if (a.type != 2 && a.ischeck) {
            nextIndex = JSON.parse(JSON.stringify(m)) * 1;
          }
        });
        if (this.rechargeNum * 1 > psCount * 1) {
          obj.qyList[psIndex].qyCount = psCount;
          obj.qyList[nextIndex].qyCount = this.rechargeNum * 1 - psCount * 1;
        } else {
          obj.qyList[psIndex].qyCount = this.rechargeNum * 1;
          obj.qyList[nextIndex].ischeck = false;
          this.packageRI = [this.packageRI[0]];
        }
      } else if (obj.qyList.length == 0) {
        console.log(obj);
      } else {
        obj.qyList[0].qyCount = 1;
        obj.qyList[0].ischeck = true;
        this.packageRI = [obj.qyList[0].type];
      }
      if (this.isPartPay == 1) return;
      setTimeout(() => {
        this.determineUse();
      }, 0);
    },
    // 5.4改折后价状态
    editDiscountPriceStatusChange(val) {
      this.editDiscountPriceStatus = val;
    },
    // 6.5改原价状态
    editOldPriceStatusChange(val) {
      this.editOldPriceStatus = val;
    },
    // 修改改价的初始金额
    editRightsPrice(val) {
      const obj = this.packageInfo;
      obj.qyList.forEach((a) => {
        a.price = val;
        a.originalPrice = val;
        a.memberPrice = obj.discountType == 0 ? (val * obj.memberDiscount / 10).toFixed(2) : obj.memberPrice;
        if (a.type == 5) {
          a.rightsPrice = val;
          a.percentage = 100;
        } else if (a.type == 4) {
          a.twoPrice = obj.discountType == 0 ? (val * obj.memberDiscount / 10).toFixed(2) : obj.memberPrice;
          a.rightsPrice = obj.discountType == 0 ? (val * obj.memberDiscount / 10).toFixed(2) : obj.memberPrice;
        }
      });
    },
    // 5.4套餐改价--重置
    resetPrice() {
      this.packageInfo.vipCardPrice = JSON.parse(JSON.stringify(this.oldVipCardPrice));
      this.editPrice = JSON.parse(JSON.stringify(this.oldVipCardPrice));
      this.editRightsPrice(JSON.parse(JSON.stringify(this.oldVipCardPrice)));
      this.computingPrice();
      this.discountPrice = ((this.isPrice() * this.rechargeNum - this.calculationDiscountMoney(99) * 1) / this.rechargeNum * 1).toFixed(2);
    },
    // 5.4套餐改价--确定
    comfirmEditPrice() {
      if (this.oldVipCardPrice * 1 > this.editPrice * 1) {
        this.$message('修改的价格不能小于原价');
        this.editPrice = JSON.parse(JSON.stringify(this.oldVipCardPrice));
        this.packageInfo.vipCardPrice = JSON.parse(JSON.stringify(this.oldVipCardPrice));
        this.editRightsPrice(JSON.parse(JSON.stringify(this.oldVipCardPrice)));
      } else {
        this.packageInfo.vipCardPrice = JSON.parse(JSON.stringify(this.editPrice));
        this.editRightsPrice(JSON.parse(JSON.stringify(this.editPrice)));
      }
      this.chooseInfoRI = JSON.parse(JSON.stringify(this.packageInfo));
      this.computingPrice();
      this.discountPrice = ((this.isPrice() * this.rechargeNum - this.calculationDiscountMoney(99) * 1) / this.rechargeNum * 1).toFixed(2);
    },
    // 6.5计算选择权益的优惠金额
    calculationDiscountMoney(val) {
      const obj = this.packageInfo;
      let one = 0;
      const arr = [];
      let four = 0;
      let five = 0;
      let total = 0;
      obj.qyList.forEach((a) => {
        if (a.ischeck == true) {
          if (a.type == 1) {
            one += (a.wholesalePrice * a.qyCount).toFixed(2);
          } else if (a.type == 2) {
            arr.push({ activityType: 1, price: ((this.packageInfo.vipCardPrice - a.rightsPrice) * a.qyCount).toFixed(2) });
            total += (this.packageInfo.vipCardPrice - a.rightsPrice) * a.qyCount;
          } else if (a.type == 3) {
            arr.push({ activityType: 2, price: ((this.packageInfo.vipCardPrice - a.rightsPrice) * a.qyCount).toFixed(2) });
            total += (this.packageInfo.vipCardPrice - a.rightsPrice) * a.qyCount;
          } else if (a.type == 4) {
            four += ((this.packageInfo.vipCardPrice - a.rightsPrice) * a.qyCount).toFixed(2);
            total += (this.packageInfo.vipCardPrice - a.rightsPrice) * a.qyCount;
          } else if (a.type == 5) {
            five += ((this.packageInfo.vipCardPrice - a.rightsPrice) * a.qyCount).toFixed(2);
            total += (this.packageInfo.vipCardPrice - a.rightsPrice) * a.qyCount;
          }
        }
      });
      if (val == 1) {
        return five * 1;
      }
      if (val == 2) {
        return four * 1;
      }
      if (val == 3) {
        return one * 1;
      }
      if (val == 4) {
        return arr;
      }
      if (val == 99) {
        return (total * 1).toFixed(2);
      }
    },
    // 计算方法
    computingPrice() {
      if (this.isPartPay == 1) return;
      setTimeout(() => {
        this.rechargeNum = parseInt(this.rechargeNum * 1, 10);
        this.settlementMsg = window.JSON.stringify({
          totalMoney: window.parseFloat(this.payamount * 1).toFixed(2),
          resulteMoney: window.parseFloat(this.payamount * 1 - this.calculationDiscountMoney(99) * 1).toFixed(2),
          others: {
            couponMsg: {
              money: 0,
              num: 0,
              cardId: ''
            },
            fenBiMsg: {
              money: 0,
              num: 0
            },
            jifenMsg: {
              money: 0,
              num: 0
            },
            resulteMoney: window.parseFloat(this.payamount * 1 - this.calculationDiscountMoney(99) * 1).toFixed(2),
          }
        });
        if (this.packageInfo.isWholesale == 0) {
          this.$refs.childConpon.selectCouponIndex = 0;
          this.$refs.childConpon.selectCouponFlag = false;
          this.$refs.childConpon.couponMsg = {
            money: 0,
            num: 0,
            cardId: ''
          };
          this.$refs.childConpon.initializeFansAndIntegral();
          this.$refs.childConpon.getDicountMoney();
        }
      }, 0);
      this.payamount = this.isPrice() * this.rechargeNum;
      this.getBuyGiftList();
    },
    // 获取支付方式数据
    getPayMethodsMsg(obj) {
      this.payType = obj;
      let tVal = 0;
      obj.forEach((a) => {
        if (a.payType == 1) {
          this.newPayamount = a.money;
        }
        tVal += a.money * 1;
      });
      this.resultAmount = tVal;
    },
    // 获取优惠券信息
    getConponMsg(obj) {
      setTimeout(() => {
        this.changeCoupon = !this.changeCoupon;
        this.settlementMsg = window.JSON.stringify({
          totalMoney: window.parseFloat(this.payamount * 1).toFixed(2),
          resulteMoney: window.parseFloat(obj.resulteMoney).toFixed(2),
          others: obj
        });
      }, 0);
    },
    // 获取结算信息数据
    getSettlementMsg(obj) {
      this.settlementMsg = window.JSON.stringify({
        totalMoney: window.parseFloat(this.payamount * 1).toFixed(2),
        resulteMoney: window.parseFloat(obj.resulteMoney).toFixed(2),
        others: obj
      });
      this.editMoneyVal = obj.editMoneyVal * 1;
    },
    // 查询顾客
    phoneSearch() {
      const vm = this;
      vm.Lib.keyboardBlur();
      vm.loading = true;
      const newStatus = vm.Lib.CheckPhone(vm.searchVal);
      if (newStatus == false && vm.searchVal) {
        vm.$message('请输入正确的手机号');
        return;
      }
      const data = {
        keyWord: vm.searchVal
      };
      getMemberCardMsg(data).then((res) => {
        if (res.code == 0) {
          vm.delMerchandiserChoose();
          if (!res.data.nickName) res.data.nickName = window.sessionStorage.rechargeName;
          vm.memberInfo = res.data ? res.data : {};
          vm.customerMsg = {
            cardNo: res.data.cardNo,
            memberName: res.data.memberName,
            memberMsg: res.data,
            phone: res.data.phone,
            money: res.data ? res.data.money : '',
            integral: res.data ? res.data.integral : '',
            fansCurrency: res.data ? res.data.fansCurrency : '',
            gradeName: res.data ? res.data.gradeName : ''
          };
          window.sessionStorage.rechargePhone = vm.searchVal;
          // 支付方式
          getOrderCode({ orderCode: vm.oldOrderCode }).then((resTwo) => {
            this.payMethods = {
              orderId: vm.partPayOrderId || '',
              money: '',
              memberMoney: res.data ? res.data.money : '',
              discountMoney: '',
              cardNo: res.data.cardNo,
              orderCode: resTwo.data.orderCode,
              ctName: res.data.ctName ? res.data.ctName : ''
            };
          });

          vm.getBeautyPackage();
        } else {
          // console.log(res);
        }
      });
    },
    // 查询单个会员套餐信息
    getBeautyPackage() {
      const data = {
        mainId: window.sessionStorage.mainId,
        phone: this.searchVal ? this.searchVal : '',
        cardId: window.sessionStorage.rechargeId
      };
      getBeautyPackageOne(data).then((res) => {
        res.data.useStoreList = res.data.useStoreList || [];
        res.data.vipCardItemInfoDto = res.data.vipCardItemInfoDto || [];
        res.data.basePackageProductList = res.data.basePackageProductList || [];
        this.onAccountAuth = res.data.onAccountAuth;
        this.packageInfo = res.data;
        this.packageInfo.qyList = [];
        this.discountPrice = res.data.isWholesale == 1 ? res.data.wholesalePrice : res.data.hasActivity == 1 ? res.data.activityInfo.activityPrice : res.data.memberPrice;
        this.editPrice = res.data.vipCardPrice;
        this.oldVipCardPrice = res.data.vipCardPrice;
        this.payamount = this.isPrice() * this.rechargeNum;
        if (res.data.countLimitType == 3) {
          this.countLimitType = '通用次数';
        } else if (res.data.countLimitType == 2) {
          this.countLimitType = '无限次数';
        } else {
          this.countLimitType = '有限次数';
        }
        this.settlementMsg = window.JSON.stringify({
          totalMoney: window.parseFloat(this.payamount * 1).toFixed(2),
          resulteMoney: window.parseFloat(this.isPrice() * this.rechargeNum).toFixed(2)
        });
        this.loading = false;
        this.chooseRI(this.packageInfo, 1);
        this.getBuyGiftList();
      });
    },
    // 选择通用优惠券
    selectCoupon(item, index) {
      this.selectCouponIndex = index;
    },
    // 选择开单员
    chooseMerchandiser() {
      getPercentageSkin({ mainId: window.sessionStorage.mainId }).then((res) => {
        this.scaleStan = res.data.scaleStan;
        this.resultType = res.data.resultType;
      });
      this.pageNum = 1;
      this.packageDialog = true;
      const files = this.percentage4PackageList;
      const arr = [];
      if (files.length > 0) {
        for (let i = 0, len = files.length; i < len; i++) {
          const item = files[i];
          arr.push(item);
        }
      }
      this.choosePackageList = arr;
      this.getPackageTCPrice();
      if (this.Lib.checkPower('beauty-1-lp', 2)) {
        this.newGetBrandList();
      } else {
        this.getStaffIdListData();
      }
    },
    newGetBrandList() {
      const data = {
        mainId: window.sessionStorage.mainId,
        cardType: 2
      };
      erpTechnicianCardByMainId(data).then((res) => {
        if (res.code == 0) {
          this.brandInfo = res.data;
          this.activeName = `${res.data.cards[0].id}`;
          this.getStaffIdListData();
        } else {
          console.log(res);
        }
      });
    },
    // 回选多选选择框
    chooseSelection(row, status) {
      const vm = this;
      setTimeout(() => {
        vm.$refs.packageTCTable.toggleRowSelection(row, status);
      }, 100);
    },
    // 获取开单员列表数据
    getStaffIdListData() {
      const data = {
        itemId: window.sessionStorage.rechargeId,
        pageNo: this.pageNum,
        keyWord: this.searchMerchandiserVal,
        pageSize: 999999,
        mainId: window.sessionStorage.mainId,
        cardId: this.brandInfo.cardOpen == 1 ? this.activeName : '', // 5.7新加  轮牌主键id
        type: 4, // 5.7新加 1：项目（选择统称） 2：项目（选择销售） 3：产品（选择销售） 4：套餐（选择销售）
      };
      getStaffBrandList(data).then((res) => {
        this.searchPackageList = res.data;
        if (this.choosePackageList.length > 0) {
          for (let i = 0; this.choosePackageList.length > i; i++) {
            for (let j = 0; this.searchPackageList.lookTechnicians.length > j; j++) {
              if (this.choosePackageList[i].technicianId == this.searchPackageList.lookTechnicians[j].technicianId) {
                this.chooseSelection(this.searchPackageList.lookTechnicians[j], true);
              }
            }
          }
          this.getPackageTCPrice();
        }
      });
    },
    // 点击搜索开单员按钮
    searchMerchandiser() {
      this.Lib.keyboardBlur();
      this.getStaffIdListData();
    },
    // 5.4  勾选禁用判断
    checkSelectable(row) {
      return !((row.state == 4 || row.state == 5 || row.state == 6));
    },
    // 选择开单员--勾选事件
    selectChoosePackageEvent(selection, row) {
      const vm = this;
      const obj = {};
      obj.isExit = row.isExit;
      obj.isGuest = 0;
      // percentageType = 1是固定提成 2是比例提成
      obj.percentageType = this.searchPackageList.percentageType;
      obj.technicianId = row.technicianId;
      obj.name = row.name;
      obj.guest = this.searchPackageList.guest;
      obj.noGuest = this.searchPackageList.noGuest;
      obj.number = row.number;
      obj.levelType = row.levelType;
      obj.noVipGuest = this.searchPackageList.noVipGuest;
      obj.vipGuest = this.searchPackageList.vipGuest;
      obj.percentage = this.memberInfo.cardNo ? this.searchPackageList.vipGuest : this.searchPackageList.guest;
      obj.points = this.memberInfo.cardNo ? this.searchPackageList.vipGuest : this.searchPackageList.guest;
      obj.technicianName = row.technicianName;
      obj.result = this.resultType == 1 ? 100 : (100 / (this.choosePackageList.length + 1)).toFixed(0);
      obj.resultIsEdit = 0;
      let chooseNum = 0;
      let index;
      for (let j = 0; vm.choosePackageList.length > j; j++) {
        if (vm.choosePackageList[j].technicianId == obj.technicianId) {
          index = j;
        } else {
          chooseNum++;
        }
      }
      if (chooseNum == vm.choosePackageList.length) {
        vm.choosePackageList.push(obj);
        vm.choosePackageSelection(obj);
      } else {
        vm.choosePackageList.splice(index, 1);
        vm.delPackageSelection(obj);
      }
      setTimeout(() => {
        vm.getPackageTCPrice();
      }, 100);
    },
    // 选择销售员工--勾选事件
    choosePackageEvent(row) {
      if (row.state == 4 || row.state == 5 || row.state == 6) return;
      const vm = this;
      const obj = {};
      obj.isExit = row.isExit;
      obj.isGuest = 0;
      // percentageType = 1是固定提成 2是比例提成
      obj.percentageType = this.searchPackageList.percentageType;
      obj.technicianId = row.technicianId;
      obj.name = row.name;
      obj.guest = this.searchPackageList.guest;
      obj.noGuest = this.searchPackageList.noGuest;
      obj.number = row.number;
      obj.levelType = row.levelType;
      obj.noVipGuest = this.searchPackageList.noVipGuest;
      obj.vipGuest = this.searchPackageList.vipGuest;
      obj.percentage = this.memberInfo.cardNo ? this.searchPackageList.vipGuest : this.searchPackageList.guest;
      obj.points = this.memberInfo.cardNo ? this.searchPackageList.vipGuest : this.searchPackageList.guest;
      obj.result = this.resultType == 1 ? 100 : (100 / (this.choosePackageList.length + 1)).toFixed(0);
      obj.resultIsEdit = 0;
      obj.technicianName = row.technicianName;
      vm.$refs.packageTCTable.toggleRowSelection(row);
      let chooseNum = 0;
      let index;
      for (let j = 0; vm.choosePackageList.length > j; j++) {
        if (vm.choosePackageList[j].technicianId == obj.technicianId) {
          index = j;
        } else {
          chooseNum++;
        }
      }
      if (chooseNum == vm.choosePackageList.length) {
        vm.choosePackageList.push(obj);
        setTimeout(() => {
          vm.getPackageTCPrice();
        }, 100);
      } else {
        vm.choosePackageList.splice(index, 1);
        setTimeout(() => {
          vm.getPackageTCPrice();
        }, 100);
      }
    },
    // 修改业绩占比
    resultChange(index, val) {
      if (val == 3) {
        this.choosePackageList[index].resultIsEdit = 1;
        if (this.choosePackageList[index].result * 1 > 100) {
          this.choosePackageList[index].result = 100;
        } else if (!this.choosePackageList[index].result) {
          this.choosePackageList[index].result = 0;
        }
        this.getPackageTCPrice();
      } else {
        if (!this.choosePackageList[index].percentage) {
          this.choosePackageList[index].percentage = 0;
        }
        this.getPackageTCPrice();
      }
    },
    // 计算套餐总业绩
    getPackageTCPrice() {
      const vm = this;
      let percentagePrice = 0;
      vm.choosePackageList.forEach((a) => {
        if (a.resultIsEdit == 0) {
          a.result = this.resultType == 1 ? 100 : (100 / (vm.choosePackageList.length * 1)).toFixed(0);
        }
      });
      if (vm.choosePackageList) {
        if (vm.choosePackageList.length > 0) {
          vm.choosePackageList.forEach((v) => {
            const newVal = v.percentageType == 1 ? (v.percentage * v.result * vm.rechargeNum / 100).toFixed(2) : (v.percentage * v.result * vm.discountPrice * vm.rechargeNum / 10000);
            percentagePrice += newVal * 1;
          });
          vm.packagePercentageTotal = (percentagePrice * 1).toFixed(2);
        } else {
          vm.packagePercentageTotal = 0;
        }
      } else {
        vm.packagePercentageTotal = 0;
      }
    },
    // 回选多选选择框
    choosePackageSelection(row) {
      const vm = this;
      setTimeout(() => {
        vm.$refs.packageTCTable.toggleRowSelection(row, true);
      }, 100);
    },
    // 回选多选选择框
    delPackageSelection(row) {
      const vm = this;
      setTimeout(() => {
        vm.$refs.packageTCTable.toggleRowSelection(row, false);
      }, 100);
    },
    // 重置选择的开单员
    delMerchandiserChoose() {
      this.choosePackageList = [];
    },
    handleSizeChange(val) {
      this.pageNum = val;
      this.getStaffIdListData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getStaffIdListData();
    },
    // 确定添加开单员
    comfirmAddPackage() {
      const files = this.choosePackageList;
      const arr = [];
      if (this.choosePackageList.length > 0) {
        for (let i = 0, len = files.length; i < len; i++) {
          const item = files[i];
          arr.push(item);
        }
      }
      this.percentage4PackageList = arr;
      this.packageDialog = false;
    },
    // 调用子组件的方法
    payPagePayMethods() {
      this.$refs.payMethods.toPay('88');
    },
    getPayData(url) {
      const vm = this;
      const settlementMsg = window.JSON.parse(vm.settlementMsg);
      if (!settlementMsg.others) {
        settlementMsg.others = {
          couponMsg: {
            cardId: '',
            money: 0,
            num: 0
          },
          fenBiMsg: {
            money: 0,
            num: 0
          },
          jifenMsg: {
            money: 0,
            num: 0
          }
        };
      }
      const newOthers = settlementMsg.others;
      const newList = [];
      if (vm.percentage4PackageList.length > 0) {
        vm.percentage4PackageList.forEach((b) => {
          const obj = {};
          obj.isGuest = 0;
          obj.isMember = this.memberInfo.cardNo ? 1 : 0;
          obj.isUpdate = ((b.isUpdate == 0) || (b.isUpdate == 1)) ? b.isUpdate
            : (((b.points * 1).toFixed(2)) == ((b.percentage * 1).toFixed(2))) ? 0 : 1;
          obj.percentageNum = b.result;
          obj.percentageNumber = b.percentage;
          obj.percentageType = b.percentageType;
          obj.resultPrice = (vm.discountPrice * b.result / 100).toFixed(2);
          obj.setType = b.levelType;
          obj.technicianId = b.technicianId;
          newList.push(obj);
        });
      }
      const partDiscountMoney = ((newOthers.couponMsg ? (newOthers.couponMsg.money * 1) : 0) + (newOthers.fenBiMsg ? (newOthers.fenBiMsg.money * 1) : 0) + (newOthers.jifenMsg ? (newOthers.jifenMsg.money * 1) : 0) + this.calculationDiscountMoney(99) * 1).toFixed(2);
      const partPayStatus = (partDiscountMoney == Math.abs((settlementMsg.totalMoney - vm.editMoneyVal * 1 - settlementMsg.resulteMoney).toFixed(2))) ? 0 : 1;
      // 优惠券金额
      const newCouponMoney = window.JSON.parse(vm.settlementMsg).others ? (window.JSON.parse(vm.settlementMsg).others.couponMsg.money || 0) : 0;
      // 粉币
      const newFenbiMoney = window.JSON.parse(vm.settlementMsg).others ? (window.JSON.parse(vm.settlementMsg).others.fenBiMsg.money || 0) : 0;
      // 积分
      const newJifenMoney = window.JSON.parse(vm.settlementMsg).others ? (window.JSON.parse(vm.settlementMsg).others.jifenMsg.money || 0) : 0;
      // 整单改价
      const newOrderChangeMoney = vm.packageInfo.orderChangeMoney ? vm.packageInfo.orderChangeMoney : vm.editMoneyVal;
      const newDiscountMoney = (newCouponMoney * 1 + newFenbiMoney * 1 + newJifenMoney * 1 + newOrderChangeMoney * 1 + (vm.isPrice() * 1 - vm.discountPrice * 1) * vm.rechargeNum).toFixed(2);
      // 选择的优惠权益列表
      const discountList = [];
      vm.packageInfo.qyList.forEach((a) => {
        if (a.ischeck) {
          const obj = {};
          obj.activityId = a.activityId;
          obj.activityType = a.activityType;
          obj.count = a.qyCount;
          obj.id = a.id;
          obj.isChangePrice = a.type == 5 ? 1 : 0;
          obj.isWholesale = a.isWholesale;
          obj.memberDiscount = a.memberDiscount;
          obj.memberPrice = a.memberPrice;
          obj.originalPrice = a.originalPrice;
          obj.rightsPrice = a.rightsPrice;
          obj.type = a.type;
          obj.twoDiscountType = a.twoDiscountType;
          obj.twoPrice = a.twoPrice;
          obj.vipCardId = vm.packageInfo.clientVipCardId ? null : window.sessionStorage.rechargeId;
          obj.vipCardOrderId = '';
          obj.wholesalePrice = a.wholesalePrice;
          discountList.push(obj);
        }
      });
      const buyGiftArr = [];
      this.buyGiftList.forEach((a) => {
        const obj = {};
        obj.activityGiftId = a.activityGiftId;
        obj.activityGiftPrice = a.activityGiftPrice;
        obj.activityId = a.activityId;
        obj.giftCount = a.buyGiftCount;
        obj.giftId = a.giftId;
        obj.giftType = a.giftType;
        buyGiftArr.push(obj);
      });
      this.fullGiftList.forEach((a) => {
        const obj = {};
        obj.activityGiftId = a.activityGiftId;
        obj.activityGiftPrice = a.activityGiftPrice;
        obj.activityId = a.activityId;
        obj.giftCount = a.buyGiftCount;
        obj.giftId = a.giftId;
        obj.giftType = a.giftType;
        buyGiftArr.push(obj);
      });
      const data = {
        activityGiftList: buyGiftArr,
        bankCode: '',
        cardId: window.JSON.parse(vm.settlementMsg).others ? window.JSON.parse(vm.settlementMsg).others.couponMsg.cardId : '',
        cardNum: window.JSON.parse(vm.settlementMsg).others ? window.JSON.parse(vm.settlementMsg).others.couponMsg.num : '',
        clientName: vm.packageInfo.clientVipCardId ? null : vm.memberInfo.nickName,
        clientVipCardId: vm.packageInfo.clientVipCardId,
        count: vm.rechargeNum,
        couponMoney: newCouponMoney,
        creditAuthorizerId: '', // 挂帐授权人id
        discountAfterMoney: vm.discountPrice,
        discountMoney: vm.isPartPay == 1 ? vm.packageInfo.discountAmount : newDiscountMoney,
        fansCurrency: window.JSON.parse(vm.settlementMsg).others ? window.JSON.parse(vm.settlementMsg).others.fenBiMsg.num : '0',
        fenbiMoney: vm.isPartPay == 1 ? vm.packageInfo.fenbiMoney : newFenbiMoney,
        integral: window.JSON.parse(vm.settlementMsg).others ? window.JSON.parse(vm.settlementMsg).others.jifenMsg.num : '0',
        isMember: vm.memberInfo.cardNo ? 1 : 0,
        jifenMoney: vm.isPartPay == 1 ? vm.packageInfo.integralMoney : newJifenMoney,
        lookOrderVipCardInfoDetailList: discountList,
        mainId: window.sessionStorage.mainId,
        memberId: vm.memberInfo.cardNo ? vm.memberInfo.memberId : 0,
        orderChangeMoney: vm.isPartPay == 1 ? vm.packageInfo.orderChangeMoney : newOrderChangeMoney,
        orderCode: vm.payMethods.orderCode,
        orderId: vm.payMethods.orderId,
        orderType: vm.packageInfo.clientVipCardId ? 2 : 0,
        orderSignature: url || '',
        partPayType: vm.isPartPay ? 2 : partPayStatus,
        payAmount: vm.isPartPay == 1 ? 0 : vm.newPayamount,
        payInfoList: vm.payType,
        phone: vm.memberInfo.phone ? vm.memberInfo.phone : vm.searchVal,
        price: vm.isPrice(),
        resultAmount: vm.resultAmount,
        returnAmount: vm.packageInfo.clientVipCardId ? vm.returnPayMoney : null,
        sex: vm.packageInfo.clientVipCardId ? null : '男',
        technicianList: newList,
        vipCardId: vm.packageInfo.clientVipCardId ? null : window.sessionStorage.rechargeId,
        vipCardName: vm.packageInfo.vipCardName
      };
      return data;
    },
    checkReceivables() {
      this.$refs.payMethods.toPay('88');
    },
    // 结算订单
    receivables(url) {
      const vm = this;
      const newStatus = vm.Lib.CheckPhone(vm.searchVal);
      if (newStatus == false || !vm.searchVal) {
        vm.$message('请输入正确的手机号，才可以进行结算');
        return;
      }
      vm.receivablesBtn = true;
      const loading = this.$loading({
        lock: true,
        text: '支付中，请稍等',
        spinner: 'el-icon-loading',
        customClass: 'loadNoneedImg',
        background: 'rgba(0, 0, 0, 0.5) !important'
      });
      if (vm.packageInfo.clientVipCardId) {
        postCardPurchase(vm.getPayData(url)).then((res) => {
          if (res.code == 0) {
            vm.closeTab(res.data.orderId);
            vm.$message({
              message: '套餐充值成功',
              type: 'success'
            });
            vm.phoneSearch();
          } else {
            vm.$message(res.msg);
          }
          vm.receivablesBtn = false;
          loading.close();
        });
      } else {
        postCardShopping(vm.getPayData(url)).then((res) => {
          if (res.code == 0) {
            vm.closeTab(res.data.orderId);
            vm.$message({
              message: '套餐购买成功',
              type: 'success'
            });
            vm.phoneSearch();
          } else {
            vm.$message(res.msg);
          }
          vm.receivablesBtn = false;
          loading.close();
        });
      }
    },
    // 关闭当前导航栏
    closeTab(id) {
      setTimeout(() => {
        this.$store.commit('deleteTabs', 'stage-recharge');
        window.sessionStorage.printOrderStatus = 1;
        this.$router.replace({
          name: 'stage-settlementSuccess'
        });
        window.sessionStorage.successOrderId = id;
        window.sessionStorage.successResulteMoney = window.JSON.parse(this.settlementMsg).resulteMoney;
        window.sessionStorage.successOrderType = 3;
      }, 100);
    },
    // 找零
    changePayamount() {
      if (this.payType.length == 1) {
        this.returnPayMoney = (this.payamount * 1 - (window.JSON.parse(this.settlementMsg).resulteMoney * 1));
      } else {
        this.returnPayMoney = 0;
      }
    },
    // (5.4)查询套餐部分支付还款页面信息
    getPackagePartPayMsg() {
      const vm = this;
      const data = { orderId: vm.partPayOrderId };
      getPackagePartPayMsg(data).then((res) => {
        // 会员信息
        if (res.data.member) {
          vm.memberInfo = res.data.member;
          vm.customerMsg = {
            cardNo: res.data.member.cardNo,
            memberName: res.data.member.nickName,
            memberMsg: res.data,
            phone: res.data.member.phone,
            money: res.data.member.money,
            integral: res.data.member.integral,
            fansCurrency: res.data.member.fansCurrency,
            gradeName: res.data.member.gradeName
          };
        } else {
          vm.memberInfo = {
            headImgUrl: '', // 会员头像地址
            nickName: res.data.clientName, // 会员名称
            receiveDate: '', // 创建时间
            fansCurrency: '', // 粉币数量
            money: '', // 余额
            cardNo: '', // 会员卡号
            integral: '', // 积分
            phone: res.data.phone // 会员手机
          };
        }
        vm.payMethods = {
          orderId: vm.partPayOrderId || '',
          money: '',
          memberMoney: res.data.member ? res.data.member.money : 0,
          discountMoney: '',
          cardNo: res.data.member ? res.data.member.cardNo : '',
          orderCode: res.data.member ? res.data.member.orderCode : '',
          ctName: res.data.member ? res.data.member.ctName : ''
        };
        vm.oldOrderCode = res.data.member ? res.data.member.orderCode : '';
        vm.packageInfo = res.data;
        vm.chooseRI(vm.packageInfo, 1);
        vm.payamount = res.data.balance;

        // 优惠金额
        vm.searchVal = window.sessionStorage.rechargePhone;
        vm.partPayTotal = res.data.alreadyRefundAmount * 1 + res.data.balance * 1;
        vm.editMoneyVal = 0;
        vm.settlementMsg = window.JSON.stringify({
          totalMoney: window.parseFloat(res.data.balance * 1).toFixed(2),
          resulteMoney: window.parseFloat(res.data.balance * 1).toFixed(2),
          money: res.data.member ? res.data.member.money : 0,
          others: {
            couponMsg: {
              money: res.data.couponMoney,
              num: res.data.couponMoney ? 1 : 0,
              cardId: ''
            },
            fenBiMsg: {
              money: res.data.fenbiMoney,
              num: res.data.fenbiMoney ? 1 : 0
            },
            jifenMsg: {
              money: res.data.integralMoney,
              num: res.data.integralMoney ? 1 : 0
            }
          }
        });
        vm.selectCouponIndex = -1;
        vm.rechargeNum = res.data.count;
        vm.discountPrice = ((vm.isPrice() * vm.rechargeNum - vm.calculationDiscountMoney(99) * 1) / vm.rechargeNum * 1).toFixed(2);
        window.sessionStorage.rechargeId = res.data.vipCardId;
        // 6.7
        vm.vipCard = {
          vipCardList: res.data.itemList ? res.data.itemList : [],
          packageSumTotal: res.data.initAmount
        };
        const arr = [];
        vm.vipCard.vipCardList.forEach((c) => {
          c.listStatus = 3;
          c.vipCardName = c.name;
          c.deductDtoList = [];
          c.percentage4PackageList = c.percentageSellServeList;
          arr.push(c);
        });
        vm.consumptionList = arr;
        console.log(arr);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.dialog_header {
  height: 48px;
  clear: both;
  p {
    line-height: 40px;
    height: 40px;
    margin-left: 27px;
    color: #666;
    font-size: 14px;
    width: 330px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    float: left;
  }
  h6 {
    line-height: 40px;
    height: 40px;
    color: #666;
    font-size: 14px;
    width: 330px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    float: right;
    text-align: right;
    label {
      color: #f56c6c;
      font-size: 18px;
    }
    samp {
      margin-left: 9px;
      text-decoration: line-through;
      font-size: 13px;
    }
  }
}
.newFootCss {
  padding: 15px 0 20px 0;
  .newFootCode {
    float: right;
    margin-top: 10px;
    .newPrice {
      color: #666;
      font-size: 14px;
      padding: 10px 0 10px 35px;
      small {
        color: #ff2233;
        font-size: 16px;
      }
    }
  }
  .newFootBtn {
    float: right;
    display: block;
    width: 100%;
    text-align: right;
    padding-top: 7px;
  }
}
.srcoll {
  width: 100%;
  height: 60px;
  padding: 10px 0;
  background-color: #f5f7fa;
  margin: 15px 0 20px 0;
  .i_one {
    float: left;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border-radius: 50%;
    background-color: #fff;
    margin: 0 20px 0 30px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    i {
      color: #999;
      font-size: 28px;
    }
  }
  .li {
    float: left;
    padding: 8px 30px 8px 0;
    h5 {
      font-size: 14px;
      color: #333;
      height: 16px;
      line-height: 16px;
    }
    p {
      font-size: 14px;
      color: #333;
      height: 28px;
      line-height: 28px;
      .liBtn {
        float: left;
        width: 180px;
        margin-right: 10px;
      }
      .i_three {
        font-size: 16px;
        color: #fd5c8c;
        padding-left: 5px;
        cursor: pointer;
      }
      span {
        float: right;
        font-size: 12px;
        background-color: #ffe9ee;
        color: #fd5c8c;
        height: 19px;
        line-height: 19px;
        border-radius: 8px;
        margin-left: 5px;
        padding: 0 5px 0 23px;
        i {
          position: relative;
          display: block;
          float: left;
          font-size: 12px;
          margin: -2px 0 0 -25px;
          background-color: #ffe9ee;
          text-align: center;
          width: 23px;
          height: 23px;
          line-height: 23px;
          border-radius: 50%;
        }
      }
    }
  }
}
/*5.4*/
.editPrice {
  width: 346px;
  p {
    background: rgba(245, 247, 250, 1);
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    padding: 0 20px;
    color: #818691;
  }
  h5 {
    height: 28px;
    line-height: 14px;
    padding: 20px;
    color: #333;
    font-size: 14px;
  }
  .epInput {
    margin: 20px;
    width: 240px;
  }
  .epBtn {
    padding: 0 20px 20px 20px;
    text-align: right;
    float: right;
  }
}
.service-items {
  font-size: 14px;
}
.margin-top-20 {
  margin-top: 20px;
}
</style>
<style>
.merchandiserDialog
  .el-table__header-wrapper
  .el-table__header
  .el-checkbox
  .el-checkbox__input
  .el-checkbox__inner {
  display: none !important;
}
.chooseServiceCss .el-dialog__body {
  overflow-x: hidden;
  padding-bottom: 10px;
}
.input-with-select .el-input__inner {
  padding-left: 36px !important;
}
.tablePointer .el-table tr {
  cursor: pointer;
}
.tablePointer .brandList {
  position: absolute;
  background-color: #F5F7FA;
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  width: 280px;
  color: #999;
  font-weight: bold;
  z-index: 1;
  overflow: hidden;
}
.tablePointer .brandList .el-tabs__item {
  width: 106px;
  padding: 0 5px;
  height: 48px;
  line-height: 48px;
  text-align: center;
}
.tablePointer .brandList .el-tabs__nav-wrap::after {
  height: 1px;
}
</style>
